<template>
  <div>
    <ul>
      <li
        v-for="(item, index) in reportItems"
        :key="index"
        class="mt-5 flex items-center justify-between"
      >
        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-3">
          <vs-checkbox
            v-model="selected[index]"
            :vs-value="item.value"
            class="ml-2"
            >{{ item.reportName }}</vs-checkbox
          >
        </div>
        <div
          v-show="index === 0 ? true : false"
          class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full"
        >
          <span class="text-sm">Year</span><span style="color: red">*</span>
          <v-select
            v-validate="'required'"
            name="yearToDate"
            v-model="yearScope"
            :options="generateArrayOfYears"
            placeholder="Please Select"
          />
          <span class="text-danger">{{
            errors.first("step-1.yearToDate")
          }}</span>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
      </li>
    </ul>

    <div class="flex justify-between flex-wrap mt-5">
      <span />
      <vs-button
        @click="onGenerateReports()"
        color="success"
        type="filled"
        icon-pack="feather"
        icon="icon-download"
        >Generate Reports</vs-button
      >
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";

import moment from "moment";
import vSelect from "vue-select";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueApexCharts from "vue-apexcharts";

import axios from "@/axios.js";
import Swal from "sweetalert2";

export default {
  props: {
    createPayroll: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      selected: [],
      reportItems: [
        {
          value: "PayrollAlphalist73",
          reportName: "Alphalist without previous employer within the year",
        },
        {
          value: "PayrollAlphalist74",
          reportName: "Alphalist with previous employer within the year",
        },
        {
          value: "PayrollAlphalist71",
          reportName:
            "Alphalist of resigned/terminated employee within the year",
        },
      ],
      yearScope: new Date().getFullYear(),
    };
  },

  computed: {
    getAllCreatePayroll() {
      return this.$store.state.payroll.getAllCreatePayroll;
    },
    tenantName() {
      return (id) => this.$store.getters["tenants/tenantName"](id);
    },
    generateArrayOfYears() {
      let createPayroll = this.getAllCreatePayroll;
      const years = [
        ...new Set(createPayroll.map((item) => item.calendarYear)),
      ];
      return years;
    },
  },
  methods: {
    onGenerateReports() {
      this.$vs.loading();
      let tenant = this.tenantName(this.$store.state.AppActiveUser.tenantsId);
      var logoPath = "";

      if (tenant.photoId != null) {
        this.$store
          .dispatch("getFile", tenant.photoId) //Get filePath of Company Logo
          .then((response) => {
            logoPath = response.data.path;
          });
      }

      const data = {
        serverName: tenant.secretKey,
        dbName: tenant.apiKey,
        userName: "",
        password: "",
        companyCode: tenant.code,
        companyName: tenant.name,
        address: tenant.address,
        photoURL: logoPath,
        createPayrollId: 0, //this.createPayroll.createPayrollId,
        printedBy: this.$store.state.AppActiveUser.uid,
        reportName: this.selected,
        payOutDate: null, //moment(this.createPayroll.payOutDate).format('YYYYMMDD'),
        creditDate: "", //moment(this.createPayroll.payOutDate).format('YYYYMMDD'),
        passwordToOpen: null,
        monthName: "",
        yearScope: this.yearScope,
        reportType: "ALPHALIST",
        userId: [this.$store.state.AppActiveUser.uid],
      };

      const options = {
        responseType: "blob",
        onDownloadProgress: (progressEvent) => {
          const p =
            Math.round(
              progressEvent.event.loaded /
                (progressEvent.event.total === 0
                  ? progressEvent.event.loaded
                  : progressEvent.event.total)
            ) * 100;
        },
      };
      this.$store.dispatch("payroll/GenerateReports", data).then(() => {
        var zipFileName = tenant.code + "_ALPHALIST.zip";
        axios
          .get(
            `/api/reports/OtherReports?dbName=${tenant.code}&fileName=${zipFileName}&reportType=ALPHALIST&monthName=0&yearScope=${this.yearScope}`,
            { reportProgress: true, responseType: "blob" }
          )
          .then((response) => {
            this.$vs.loading.close();
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", zipFileName);
            document.body.appendChild(link);
            link.click();

            Swal.fire({
              title: "Done",
              html: "Alphalist Reports Generated",
              icon: "success",
              timer: 2000,
              timerProgressBar: true,
            });
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$alert(error.message, "Error", "error");
          });
      });
    },
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    flatPickr,
    VueApexCharts,
    Swal,
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
